export function emojiAwareInitials(name: string, numberOfInitials = 2) {
  const words = name.split(" ").slice(0, numberOfInitials);

  return words.map((word) => [...word][0]).join("");
}
